export class ShortUrlRequestModel {
    url;
}
export class ShortUrlModel {
    id;
    url;
    accountId;
    createdAt;
}
//# sourceMappingURL=short-url.js.map